export default [
  {
    name: 'Dashboard',
    path: '/dashboard',
    meta: { title: '仪表盘', icon: 'el-icon-s-data' }
  },
  {
    name: 'User',
    path: '/TgUser',
    meta: { title: '用户管理', icon: 'el-icon-user', alwaysShow: true },
    children: [
      { name: 'UserList', path: '/TgUser/list', meta: { title: '用户列表' } }
    ]
  },
  {
    name: 'Group',
    path: '/TgGroup',
    meta: { title: '群组管理', icon: 'el-icon-s-tools', alwaysShow: true },
    children: [
      { name: 'GroupList', path: '/TgGroup/list', meta: { title: '群组列表' } }
    ]
  },
  {
    name: 'config',
    path: '/tgconfig',
    meta: { title: '配置管理', icon: 'el-icon-s-finance', alwaysShow: true },
    children: [
      { name: 'TgconfigList', path: '/tgconfig/list', meta: { title: '配置列表' } }
    ]
  },
  {
    name: 'Permission',
    path: '/permission',
    meta: { title: '权限管理', icon: 'el-icon-lock', alwaysShow: true },
    children: [
      { name: 'PermissionList', path: '/permission/list', meta: { title: '权限列表' } }
    ]
  },
  {
    name: 'Bot',
    path: '/TgBot',
    meta: { title: 'Bot 管理', icon: 'el-icon-s-platform', alwaysShow: true },
    children: [
      { name: 'BotList', path: '/TgBot/list', meta: { title: 'Bot 列表' } }
    ]
  }
]
